import {  useState } from "react";
import { supabaseClient } from "./supabaseClient";

const Register = () => {
    const [email, setEmail] = useState<string>('')
    const [password, setPassword] = useState<string>('')
    const [confirmPassword, setConfirmPassword] = useState<string>('')
    const [errorMsg, setErrorMsg] = useState("");
    const [msg, setMsg] = useState("");
    const [loading, setLoading] = useState(false);

    const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(event.target.value)
    };

    const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(event.target.value)
    };

    const handleConfirmPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setConfirmPassword(event.target.value)
    };

    const handleSubmit = async (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        if (
            password === '' ||
            email === '' ||
            confirmPassword === ''
        ) {
            setErrorMsg("Please fill all the fields");
            return;
        }
        if (password !== confirmPassword) {
            setErrorMsg("Passwords doesn't match");
            return;
        }
        try {
            setErrorMsg("");
            setLoading(true);
            const { data, error } = await supabaseClient.auth.signUp({
                email,
                password,
              })
            if (!error && data) {
                setMsg(
                    "Registration Successful. Check your email to confirm your account"
                );
            } 
            if (error){
                setErrorMsg(String(error) || '');
            }
        } catch (error) {
            setErrorMsg("Error in Creating Account");
        }
        setLoading(false);
    };

    return (
        <>
            <div className="grid card rounded-box ">
                <div className="px-4 py-5 sm:p-6">
                    <h2 className="text-center text-2xl font-bold mb-4">Register</h2>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-4">
                            <label htmlFor="email" className="block text-sm font-bold text-gray-700 mb-2">Email</label>
                            <input type="email" onChange={handleEmailChange} required className="input input-bordered w-full pl-4 bg-white" />
                        </div>
                        <div className="mb-4">
                            <label htmlFor="password" className="block text-sm font-bold text-gray-700 mb-2">Password</label>
                            <input type="password" onChange={handlePasswordChange} required className="input input-bordered w-full pl-4 bg-white" />
                        </div>
                        <div className="mb-4">
                            <label htmlFor="confirm-password" className="block text-sm font-bold text-gray-700 mb-2">Confirm Password</label>
                            <input type="password" onChange={handleConfirmPasswordChange} required className="input input-bordered w-full pl-4 bg-white" />
                        </div>
                        {errorMsg && (
                            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
                                <span className="block sm:inline">{errorMsg}</span>
                                <span className="absolute top-0 bottom-0 right-0 px-4 py-3" onClick={() => setErrorMsg("")}>
                                    <svg className="fill-current h-6 w-6 text-red-500" role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><title>Close</title><path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" /></svg>
                                </span>
                            </div>
                        )}
                        {msg && (
                            <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative" role="alert">
                                <span className="block sm:inline">{msg}</span>
                                <span className="absolute top-0 bottom-0 right-0 px-4 py-3" onClick={() => setMsg("")}>
                                    <svg className="fill-current h-6 w-6 text-green-500" role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><title>Close</title><path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" /></svg>
                                </span>
                            </div>
                        )}
                        <div className="text-center mt-2">
                            <button disabled={loading} type="submit" className="w-1/2 text-xl font-semibold p-2 btn-primary rounded-full mt-4 md:mt-auto items-center justify-center">
                                Register
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default Register;